export const GET_BENCHMARK_LIST = 'GET_BENCHMARK_LIST';

export const getBenchmarkList = benchmarks => ({
  type: GET_BENCHMARK_LIST,
  ...benchmarks,
});
